<template>
  <v-text-field
    dense
    :readonly="readonly"
    label="Demo ID"
    v-model="selected"
    :rules="demoIdRules"
    hide-details="auto"
  ></v-text-field>
</template>

<script>
  export default {
    props: {
      initialValue: {
        type: String,
        default: null,
      },
      readonly: {
        type: Boolean,
        default: false,
      },
    },
    data: function () {
      return {
        demoIdRules: [value => (value && !isNaN(value)) || value === '' || 'Numeric values only'],
      }
    },
    computed: {
      selected: {
        get() {
          return this.initialValue || ''
        },
        set(newVal) {
          this.$emit('updatedDemoId', newVal)
        },
      },
    },
  }
</script>



// WEBPACK FOOTER //
// DemoId.vue?5f2b46e2